import  React                                     ,
       { useState                                 ,
         useEffect                                }  from 'react';
import { Link                                     }  from 'react-router-dom';
import   classNames                                  from 'classnames';

import { Tab                                      , 
         Tabs                                     , 
		 TabList                                  , 
		 TabPanel                                 }  from 'react-tabs';
		 
import 'react-tabs/style/react-tabs.css';

import   styles                                      from './window_cookies_manager_2.module.scss';

import { Toggle                                   }  from '../../widget/toggle/toggle';

import { getAnalysisCookiesConsent                ,
         getMarketingCookiesConsent               ,
         updateAnalysisCookiesConsent             ,
         updateMarketingCookiesConsent            ,
		 updateAllCookiesConsentFromCookiesValues }  from '../../../network/utils';

import { postRgpdConsentLog                       }  from '../../../network/api_rgpd_consent_log';

import { WWW_URLS                                 }  from '../../../network/urls';

export interface WindowCookiesManager2Props {
  onClickOnCloseButton: (() => void)
}

export const WindowCookiesManager2 = ({ onClickOnCloseButton }: WindowCookiesManager2Props) => {

  const [ cookiesAnalyse   , setCookiesAnalyse   ] = useState ( getAnalysisCookiesConsent()  === 1 );
  const [ cookiesMarketing , setCookiesMarketing ] = useState ( getMarketingCookiesConsent() === 1 );

  useEffect(() => {

  });
  
  const handleClick = () => {

    let functionalCookiesConsent = 1;  // On le force à 1 en théorie ???
    let analysisCookiesConsent   = 0;
    let marketingCookiesConsent  = 0;

    if ( cookiesAnalyse ) 
          { 
           updateAnalysisCookiesConsent (1);
		   analysisCookiesConsent = 1;
          }
     else {
           updateAnalysisCookiesConsent (-1);
		   analysisCookiesConsent = -1
          }
          
    if ( cookiesMarketing ) 
          { 
           updateMarketingCookiesConsent (1);
		   marketingCookiesConsent = 1;
          }
     else {
           updateMarketingCookiesConsent (-1);
		   marketingCookiesConsent = -1;
          }

    let allCookiesConsent = updateAllCookiesConsentFromCookiesValues ();
	
	postRgpdConsentLog ( 
	                     allCookiesConsent,   
						 functionalCookiesConsent, 
						 analysisCookiesConsent,  
						 marketingCookiesConsent
					   );
	

    onClickOnCloseButton();
  };
  
    const handleCookiesAnalyseConsentChange  = (newState: boolean) => {
	
    setCookiesAnalyse(newState);
  };

    const handleCookiesMarketingConsentChange  = (newState: boolean) => {
	 
    setCookiesMarketing(newState);
  };
   

  return (
            <>

            <div className={classNames(styles.window)}>
              
              <div className={classNames(styles.block_informations)}>

                <Tabs>
				
                 <TabList>
                  <Tab>Cookies fonctionnels</Tab>
                  <Tab>Cookies d’analyse</Tab>
                  <Tab>Cookies de marketing</Tab>
                 </TabList>

                 <TabPanel>
                   <p className={classNames(styles.text_rgpd)}>
				    Toujours actif
				   </p>
				   <br/>
                   <p className={classNames(styles.text_rgpd)}>
                    Ces cookies sont indispensables au bon fonctionnement du site web 
                    et ne peuvent pas être désactivés de nos systèmes. Ils ne sont 
                    généralement qu'activés en réponse à des actions que vous 
                    effectuez et qui correspondent à une demande de services, comme 
                    la configuration de vos préférences de confidentialité, la 
                    connexion ou le remplissage de formulaires. Vous pouvez configurer 
                    votre navigateur pour bloquer ou être alerté de l'utilisation de 
                    ces cookies. Cependant, si cette catégorie de cookies - qui ne 
                    stocke aucune donnée personnelle - est bloquée, certaines parties 
                    du site ne pourront pas fonctionner.
                   </p>
				   <br/>
                   <p className={classNames(styles.text_rgpd)}>
				    <Link to        ={WWW_URLS.CookiesInformation} 
					      target    ="_blank" 
						  className = { classNames(styles.link) }>Détails des cookies</Link>
				   </p>
				   <br/>                
                   <div className = {classNames(styles.block_toggle)} >

                     NON&nbsp;
					 <Toggle checked  = {true} 
					         form     = "switch" 
							 readOnly = {true} />
					 &nbsp;OUI

				   </div>
				   
                 </TabPanel>
               
                 <TabPanel>
                   <p className={classNames(styles.text_rgpd)}>
                    Ces cookies nous permettent de déterminer le nombre de visites 
                    et les sources du trafic sur notre site web, afin d'en mesurer et 
                    d’en améliorer les performances. Ils nous aident également à 
                    identifier les pages les plus / moins visitées et à évaluer 
                    comment les visiteurs naviguent sur le site. Toutes les 
                    informations, collectées par ces cookies, sont agrégées et donc 
                    anonymisées. Si vous n'acceptez pas cette catégorie de cookies, 
                    nous ne pourrons pas savoir quand vous avez réalisé votre visite 
                    sur notre site web.
				   </p>
				   <br/>
                   <p className={classNames(styles.text_rgpd)}>
				    <Link to        = {WWW_URLS.CookiesInformation} 
					      target    = "_blank" 
						  className = { classNames(styles.link) }>Détails des cookies</Link>
				   </p>
				   <br/>                
                   <div className = {classNames(styles.block_toggle)} >
			   
                     NON&nbsp;
                     <Toggle checked  = {cookiesAnalyse} 
					         form     = "switch"
                             onChange = {handleCookiesAnalyseConsentChange} />
					 &nbsp;OUI
							 
				   </div>
				   
                 </TabPanel>
               
                 <TabPanel>
                   <p className={classNames(styles.text_rgpd)}>
                    Ces cookies peuvent être activés sur notre site web par nos 
                    partenaires publicitaires. Ils peuvent être utilisés par ces 
                    entreprises pour établir des profils sur vos intérêts, et afin de 
                    vous proposer des publicités ciblées sur d’autres sites. 
                    Ils fonctionnement uniquement en identifiant votre navigateur et 
                    votre appareil. Si vous n'acceptez pas cette catégorie de cookies, 
                    des publicités moins ciblées sur vos intérêts vous seront 
                    proposées lors de votre navigation sur d'autres sites web.
				   </p>
  				   <br/>
                   <p className={classNames(styles.text_rgpd)}>
				    <Link to        = {WWW_URLS.CookiesInformation} 
					      target    = "_blank" 
						  className = { classNames(styles.link) }>Détails des cookies</Link>
				   </p>
				   <br/>                
                   <div className = {classNames(styles.block_toggle)} >

                     NON&nbsp;
                     <Toggle checked  = {cookiesMarketing} 
					         form     = "switch"
                             onChange = {handleCookiesMarketingConsentChange} />
					 &nbsp;OUI
							 
                   </div>
						   
                 </TabPanel>
               
                </Tabs>

              </div>
              
              <br/>

              <div className = {classNames(styles.block_buttons)} >
            
                <button className = "px-3 py-1 rounded-full bg-[#FFFFFF] font-bold text-sm text-black tracking-widest uppercase transform border border-black hover:scale-105 hover:bg-[#E8FF33] hover:text-black hover:border-yellow-500 transition-colors duration-200"
                        onClick   = {handleClick}>
                   Valider les réglages
                </button>
			
              </div>             
            
            </div>
            
            </>
         );
};

export default WindowCookiesManager2;
